import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { pacoteCampanhaSituacaoAtivo, pacoteCampanhaSituacaoInativo } from '../pacote-campanha-situacao';

@Component({
    selector: 'sgt-pacote-campanha-situacao-multiselect',
    templateUrl: './pacote-campanha-situacao-multiselect.component.html',
    styleUrls: ['./pacote-campanha-situacao-multiselect.component.less']
})
export class PacoteCampanhaSituacaoMultiselectComponent implements OnInit {
    /** Situações selecionadas */
    @Input() situacoes: number[];
    /** Ao alterar a seleção das situações */
    @Output() situacoesChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todas';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhuma situação';
    @Input() checked = 'Situação'
    @Input() checkedPlural = 'Situações';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todas Selecionadas';
    @Input() searchEmptyResult = 'Nenhuma situação encontrada';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    @Input() isShowAtivo = true;
    @Input() isShowInativo = true;
    // Options
    options: IMultiSelectOption[];


    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-pacote-campanha-situacao ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle,
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria as situações para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        if (this.isShowAtivo) {
            selects.push({
                id: pacoteCampanhaSituacaoAtivo.id,
                name: pacoteCampanhaSituacaoAtivo.nome,
                classes: 'multiselect-item-pacote-campanha-situacao multiselect-item-pacote-campanha-situacao-ativo'
            });
        }
        if (this.isShowInativo) {
            selects.push({
                id: pacoteCampanhaSituacaoInativo.id,
                name: pacoteCampanhaSituacaoInativo.nome,
                classes: 'multiselect-item-pacote-campanha-situacao multiselect-item-pacote-campanha-situacao-inativo'
            });
        }

        this.options = selects;
    }

    /** Ao alterar a seleção das situações */
    onChange() {
        this.situacoesChange.emit(this.situacoes);
    }
}
